/**
 * Env accessor for the policy evaluation frontend module.
 * REACT_APP_APP_ID mirrors the backend's DATA_PLATFORM_APP_ID (see etmf-server/.env).
 * REACT_APP_HUB_FRONTEND_URL already exists (used elsewhere for Hub links).
 */
export const config = {
  APP_ID: process.env.REACT_APP_APP_ID || '',
  HUB_LOGIN_URL: process.env.REACT_APP_HUB_FRONTEND_URL || '',
};

/**
 * IND package feature flag. Off unless REACT_APP_ENABLE_IND is exactly 'true';
 * when off, every IND entry point (nav tab, Study Setup option, dashboard
 * column, routes, document map, audit-trail filters) is hidden.
 */
export const IND_ENABLED = process.env.REACT_APP_ENABLE_IND === 'true';

export default config;
